module.exports = __webpack_public_path__ + "img/G5.b9918e43.jpg";